import React from 'react'
import { isKiosk } from '../utils'
import styled from 'styled-components'
import { useConfig } from '../lib'

export const Loader = ({
   inline,
   spinner,
   component,
   type = 'default',
   style,
}) => {
   const { KioskConfig } = useConfig()
   if (!inline && spinner) return <SpinnerLoader style={style} />
   if (inline) return <InlineLoader />
   if (component)
      return (
         <div className="hern-loader__component">
            <InlineLoader />
         </div>
      )
   return <>{getLoader(type, KioskConfig)}</>
}
const InlineLoader = () => {
   const isKioskMode = React.useMemo(() => {
      return isKiosk()
   }, [])
   return (
      <StyledLoader
         dotColor={isKioskMode ? '--hern-primary-color' : '--hern-accent'}
      >
         <div />
         <div />
         <div />
         <div />
      </StyledLoader>
   )
}
const SpinnerLoader = ({
   style: {
      width = '50px',
      height = '50px',
      borderWidth = '5px',
      ...restStyle
   } = {},
}) => (
   <div
      className="hern-spinner-loader"
      style={{ width, height, borderWidth: borderWidth, ...restStyle }}
   ></div>
)
const getLoader = (type, config) => {
   switch (type) {
      case 'cart-loading':
         return (
            <div className="hern-loader__wrapper">
               <img src="/assets/gifs/cart_loader.gif" />
            </div>
         )
      case 'order-loading':
         return (
            <div className="hern-loader__wrapper">
               <img src="/assets/gifs/pan_loader.gif" />
            </div>
         )
      case 'brand-loading':
         if (config?.preloadedImages?.loader?.value) {
            return (
               <div className="hern-loader__wrapper">
                  <img src={config?.preloadedImages?.loader?.value} />
               </div>
            )
         }
         return (
            <div className="hern-loader__wrapper">
               <img src={`/images/default/loader.gif`} />
            </div>
         )
      case 'paymentCancel':
         if (config?.preloadedImages?.paymentCancel?.value) {
            return (
               <div>
                  <img src={config?.preloadedImages?.paymentCancel?.value} />
               </div>
            )
         }
         return (
            <div>
               <img src={`/images/default/paymentCancel.gif`} />
            </div>
         )
      case 'paymentProcessing':
         if (config?.preloadedImages?.paymentProcessing?.value) {
            return (
               <div>
                  <img
                     src={config?.preloadedImages?.paymentProcessing?.value}
                  />
               </div>
            )
         }
         return (
            <div>
               <img src={`/images/default/paymentProcessing.gif`} />
            </div>
         )
      case 'paymentSuccess':
         if (config?.preloadedImages?.paymentSuccess?.value) {
            return (
               <div>
                  <img src={config?.preloadedImages?.paymentSuccess?.value} />
               </div>
            )
         }
         return (
            <div>
               <img src={`/images/default/paymentSuccess.gif`} />
            </div>
         )
      case 'paymentSwipeCard':
         if (config?.preloadedImages?.paymentSwipeCard?.value) {
            return (
               <img src={config?.preloadedImages?.paymentSwipeCard?.value} />
            )
         }
         return (
            <div>
               <img src={`/images/default/paymentSwipeCard.gif`} />
            </div>
         )

      default:
         return (
            <div className="hern-loader__wrapper">
               <InlineLoader />
            </div>
         )
   }
}

const StyledLoader = styled.div`
   width: 80px;
   height: 13px;
   margin: 16px auto;
   position: relative;
   > div {
      width: 13px;
      height: 13px;
      position: absolute;
      border-radius: 50%;
      background: ${({ dotColor }) => `var(${dotColor})`};
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
   }
   div:nth-of-type(1) {
      left: 8px;
      animation: lds-ellipsis1 0.6s infinite;
   }
   div:nth-of-type(2) {
      left: 8px;
      animation: lds-ellipsis2 0.6s infinite;
   }
   div:nth-of-type(3) {
      left: 32px;
      animation: lds-ellipsis2 0.6s infinite;
   }
   div:nth-of-type(4) {
      left: 56px;
      animation: lds-ellipsis3 0.6s infinite;
   }
   @keyframes lds-ellipsis1 {
      0% {
         transform: scale(0);
      }
      100% {
         transform: scale(1);
      }
   }
   @keyframes lds-ellipsis3 {
      0% {
         transform: scale(1);
      }
      100% {
         transform: scale(0);
      }
   }
   @keyframes lds-ellipsis2 {
      0% {
         transform: translate(0, 0);
      }
      100% {
         transform: translate(24px, 0);
      }
   }
`
